import React from "react";
import styled from "styled-components";
import { LanguageCode } from "../../../../amorg-common";
import { mediaQuery } from "../../../../designSystem/BreakPoints";
import { LanguageSelector } from "../../../../designSystem/compositeComponents/LanguageSelector";
import { stxt } from "../../../../SurveyTxt";
import { PublicPageProvider } from "../../../_contexts/PublicPageContext";

export function SurveyAnswerPageWrapper(
    props: React.PropsWithChildren<{
        availableLanguages: LanguageCode[],
        selectedLanguage: LanguageCode,
        onSelectedLanguageChange:(languageCode: LanguageCode)=>void
    }>
): JSX.Element {

    const txt = stxt(props.selectedLanguage);

    return (
        <PublicPageProvider>
            
            <PageWrapper>

                <Header title={txt.answerPage_header} availableLanguages={props.availableLanguages} 
                    selectedLanguage={props.selectedLanguage} onSelectedLanguage={props.onSelectedLanguageChange} />

                <ContentWrapper>
                    <Content>

                        {props.children}

                    </Content>
                </ContentWrapper>

            </PageWrapper>
        </PublicPageProvider>
    );
}

function Header(props:{
    title: string;
    availableLanguages:LanguageCode[], 
    selectedLanguage:LanguageCode, 
    onSelectedLanguage:(languageCode:LanguageCode)=>void
}):JSX.Element {
    return (
        <HeaderWrapper>
            <HeaderContent> 
                    
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <LogoWrapper>
                        <img src="/images/amorg_logo_blue.svg" />
                    </LogoWrapper>

                    <Title>
                        {props.title}
                    </Title>
                </div>

                {props.availableLanguages.length > 1 && props.selectedLanguage &&
                    <LanguageSelector
                        availableLanguages={props.availableLanguages}
                        selectedLanguage={props.selectedLanguage}
                        onSelectedLanguageChange={(languageCode) => props.onSelectedLanguage(languageCode)} />
                }

            </HeaderContent>
        </HeaderWrapper>
    );
}

const maxWidth = 1020;

const LogoWrapper = styled.div`
    align-self: start;
    height: 50px;
    left: 20px;
    position: sticky;
    top: 20px;
    width: 50px;
    margin: 0;

    img {
        display: block;
    }
`;

const PageWrapper = styled.div`
    width: 100%;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    background-color: #ccc;
    gap: 2px;
`;

const HeaderWrapper = styled.div`
    width: 100%;
    background-color: #f8f8f8;
    padding: 4px 20px;
`;
const HeaderContent = styled.div`
    display: flex;
    justify-content: space-between;
    max-width: ${maxWidth}px;
    margin: 0 auto;
`;

const ContentWrapper = styled.div`
    flex: 1;
    width: 100%;
    background-color: #f8f8f8;
    padding: 0 4px;

    ${mediaQuery.tablet} {
        padding: 0 20px;
    }

`;
const Content = styled.div`
    max-width: ${maxWidth}px;
    margin: 0 auto;
    height: 100%;
`;

const Title = styled.h1`
    font-size: 24px;
    font-weight: 500;
    margin: 0;
    padding: 0 20px;
    align-self: center;

    display: none;
    ${mediaQuery.tablet} {
        display: block;
    }

`;